import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Print invoice function
export const printInvoice = (invoiceElement) => {
  try {
    // Create a temporary container
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '0';
    tempContainer.style.width = '800px';
    tempContainer.style.backgroundColor = 'white';
    tempContainer.style.padding = '20px';
    tempContainer.className = 'invoice-print-container';
    
    // Add to DOM temporarily
    document.body.appendChild(tempContainer);
    
    // Render the invoice element into the container
    const root = ReactDOM.createRoot(tempContainer);
    root.render(invoiceElement);
    
    // Wait for render to complete
    setTimeout(() => {
      // Print the current page
      window.print();
      
      // Clean up after printing
      setTimeout(() => {
        root.unmount();
        document.body.removeChild(tempContainer);
      }, 1000);
    }, 500);
  } catch (error) {
    console.error('Error in printInvoice:', error);
    throw error;
  }
};

// Generate PDF function
export const generatePDF = async (invoiceElement, filename) => {
  try {
    // Create a temporary container
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '0';
    tempContainer.style.width = '800px';
    tempContainer.style.backgroundColor = 'white';
    tempContainer.style.padding = '20px';
    tempContainer.style.fontFamily = 'Arial, sans-serif';
    tempContainer.className = 'invoice-print-container';
    
    // Add to DOM temporarily
    document.body.appendChild(tempContainer);
    
    // Render the invoice element into the container
    const root = ReactDOM.createRoot(tempContainer);
    root.render(invoiceElement);
    
    // Wait for render to complete
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Convert to canvas
    const canvas = await html2canvas(tempContainer, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      width: 800,
      height: tempContainer.scrollHeight,
      logging: false,
      removeContainer: false
    });
    
    // Clean up
    root.unmount();
    document.body.removeChild(tempContainer);
    
    // Create PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 295; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    
    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    
    // Add additional pages if needed
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    // Download PDF
    pdf.save(filename || `invoice-${Date.now()}.pdf`);
    
    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};

// Format currency for PDF (without React context)
export const formatCurrency = (amount, currency = 'INR') => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  }).format(amount);
};

// Format date for PDF
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}; 